import styled from 'styled-components'

import { BREAKPOINTS, COLOURS } from 'resources'

export const RightSideContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`

export const LeftSideContainer = styled.div`
  width: 400px;
  height: 100%;
  max-height: 100vh;
  display: none;
  background-color: ${COLOURS.neutralBlack};
  flex-shrink: 0;

  @media (min-width: ${BREAKPOINTS.lg}) {
    display: flex;
  }
`
export const LayoutContainer = styled.div`
  flex: 1;
  display: flex;
`
